import { RootState } from '@app/index';

export const selectUserNameError = ({ profileSetting: { userNameError } }: RootState) => userNameError;
export const selectUserPhotoError = ({ profileSetting: { userPhotoError } }: RootState) => userPhotoError;
export const selectEmailError = ({ profileSetting: { emailError } }: RootState) => emailError;
export const selectPasswordForEmailError = ({ profileSetting: { passwordForEmailError } }: RootState) =>
  passwordForEmailError;
export const selectPasswordError = ({ profileSetting: { passwordError } }: RootState) => passwordError;
